<template>
<b-col
  :class="[
    'grocery-list',
    { embedded: this.isEmbed && !this.onTabletUp, itemSelected: this.selectedItem, 'screen-lg': this.onTabletUp, visible: this.isListActive },
  ]"
>
  <div class="grocery-list-header">
    <h2 v-if="this.onTabletUp">
      <span class="icon-clipboard" @click="this.setToggleList"> <svg svg-inline="" focusable="false" role="presentation" width="26" height="31" viewBox="0 0 26 31" xmlns="http://www.w3.org/2000/svg"><path d="M13 0a4.99 4.99 0 00-2.941.96l-1.346.983H1.5c-.826 0-1.5.675-1.5 1.503v26.051C0 30.325.674 31 1.5 31h23c.826 0 1.5-.675 1.5-1.503V3.447c0-.829-.674-1.504-1.5-1.504h-7.213L15.941.961A4.99 4.99 0 0013 0zm0 1.004c.824 0 1.648.256 2.352.767l2.03 1.48c.388.281.618.737.618 1.217v.982a.501.501 0 01-.5.501h-9a.501.501 0 01-.5-.5v-.983c0-.48.23-.936.617-1.218l2.031-1.479A3.97 3.97 0 0113 1.004zm0 .94a1 1 0 00-1 1.001 1 1 0 102 0 1 1 0 00-1-1.002zm-11.5 1h6.02c-.33.433-.52.967-.52 1.523v.481H4c-.55 0-1 .45-1 1.002v21.041c0 .552.45 1.002 1 1.002h14.086c.4 0 .777-.156 1.06-.44l3.415-3.42A1.5 1.5 0 0023 23.069V5.951c0-.552-.45-1.002-1-1.002h-3v-.481c0-.556-.19-1.09-.52-1.523h6.02c.275 0 .5.225.5.501v26.051a.501.501 0 01-.5.501h-23a.501.501 0 01-.5-.5V3.445a.5.5 0 01.5-.5zM4 5.951h3.092A1.5 1.5 0 008.5 6.953h9a1.5 1.5 0 001.408-1.002H22v17.033h-3c-.55 0-1 .45-1 1.002v3.006H4V5.952zm1.5 2.004a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zm2.5 0a.5.5 0 00-.5.501v1.002a.5.5 0 101 0V8.456a.5.5 0 00-.5-.501zM8 12.464a.5.5 0 00-.354.147L7 13.258l-.146-.146a.501.501 0 00-.707.708l.5.5a.496.496 0 00.707 0l1-1.001A.501.501 0 008 12.464zm2.5.5a.5.5 0 000 1.003h9a.5.5 0 000-1.002h-9zM8 15.47a.5.5 0 00-.354.146L7 16.264l-.146-.147a.501.501 0 00-.707.708l.5.502a.496.496 0 00.707 0l1-1.002A.501.501 0 008 15.47zm2.5.5a.5.5 0 000 1.003h7a.5.5 0 000-1.002h-7zM8 18.477a.5.5 0 00-.354.146L7 19.27l-.146-.147a.501.501 0 00-.707.708l.5.502a.496.496 0 00.707 0l1-1.002A.501.501 0 008 18.476zm2.5.5a.5.5 0 000 1.002h8a.5.5 0 000-1.001h-8zM8 21.482a.5.5 0 00-.354.147L7 22.276l-.146-.147a.501.501 0 00-.707.708l.5.502a.496.496 0 00.707 0l1-1.002A.501.501 0 008 21.48zm2.5.501a.5.5 0 000 1.002h3a.5.5 0 000-1.002h-3zm8.5 2.004h2.293L19 26.284v-2.298z"/></svg> </span>{{ $t('lblGroceryList') }}
    </h2>
    <!--<div class="grocery-list-subheader" v-if="shoppingEnabled">
      <BaseButton type="button" :class="['btn-primary', { 'btn-coming-soon': (shoppingData.recipeData || []).length === 0 }]" @click="startShopping">
        {{ $t('lblStartShopping') }}
      </BaseButton>
    </div> -->
  </div>

  <GroceryListTabs
    v-if="this.groceryList"
    :groceryList="this.groceryList"
    :onTabletUp="this.onTabletUp"
    :isEmbed="this.isEmbed && !this.onTabletUp"
    @select-item="onSelectItem"
  />
  <b-modal v-model="this.isShowModal" title="Share Grocery List" centered :hide-footer="true" :hide-header="true" size="sm" @hidden="cancel">
    Enter an email to send Grocery List
    <div class="inputEmail">
      <BaseInputCustomItem :class="{ 'email-error': this.emailError }" type="username" name="username" v-model="email" placeholder="Email Address" />
    </div>
    <p class="errorMsg" v-if="this.emailError">{{ this.emailError }}</p>
    <template v-slot:modal-footer="{ hide, cancelLeftovers }">
      <div>
        <BaseButton class="btn-block" @click="ok()">
          Send
        </BaseButton>
      </div>
      <div>
        <BaseButton class="btn-clear btn-block" @click="cancel()">
          Cancel
        </BaseButton>
      </div>
    </template>
  </b-modal>
</b-col>
</template>

<script>
import store from '@state/store';
import environment from '@src/environment';
import { gtmMixin } from 'gtmMixin';
import GroceryListTabs from './GroceryListTabs.vue';
import appConfig from '@src/app.config.ES6';
import { authComputed, groceryListComputed, groceryListMethods, mainComputed, kitchenDrawerComputed, kitchenDrawerMethods } from '@state/helpers';

export default {
  mixins: [gtmMixin],
  components: {
    GroceryListTabs,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      groceryListComponent: 'GroceryListTabs',
      shoppingData: {},
      shoppingEnabled: false,
      groceryListShare: [],
      email: '',
      emailError: null,
    };
  },
  computed: {
    ...authComputed,
    ...kitchenDrawerComputed,
    ...groceryListComputed,
    ...mainComputed,
  },
  async created() {
    await this.getGroceryList();

    if (this.groceryList) {
      this.groceryList.forEach((element) => {
        const categName = [];
        element.groceryItems.forEach((eleme) => {
          categName.push({ name: eleme.name, amount: eleme.count });
        });
        if (categName.length > 0) {
          this.groceryListShare.push({ categoryName: element.name, data: categName });
        }
      });
    }
  },
  mounted() {
    this.container = this.$el;
    this.container.scrollTop = this.lastScrollTop;
    const parser = require('ua-parser-js');

    this.shoppingEnabled = false;
    this.agentDetails = parser();
    this.browserDetails = this.agentDetails.browser.name.toLowerCase();

    if (appConfig.SHOPPING_ENABLED || (!this.browserDetails.includes('webview') && !this.browserDetails.includes('webkit'))) {
      this.shoppingEnabled = true; // Temporarily disable shopping
      this.getShoppingData().then((shoppingData) => {
        shoppingData.needNativeHelp = this.browserDetails.includes('webview') || this.browserDetails.includes('webkit');
        this.shoppingData = shoppingData;
      });
    }
  },
  methods: {
    ...groceryListMethods,
    ...kitchenDrawerMethods,
    onScrollChange() {
      store.dispatch('main/setLastScrollTop', { lastScrollTop: this.$el.scrollTop });
    },
    onSelectItem(item) {
      this.setSelectedItem(item);
      this.groceryListComponent = 'BaseGroceryListDetail';
    },

    ok() {
      if (this.formValid()) {
        const params = {
          email: this.email,
          groceryList: this.groceryListShare,
        };

        this.shareGroceryList(params).then((res) => {
          this.setShowModal();
          if (res.status == 404) {
            this.$toasted.error('An error has ocurred');
          } else {
            this.$toasted.success('Grocery list has been sent');
          }
        });
      }
    },
    cancel() {
      if (this.isShowModal == true) {
        this.setShowModal();
        this.email = '';
      }
    },
    formValid() {
      if (this.email && this.email.includes('@')) {
        return true;
      } else {
        if (!this.email) {
          this.emailError = `Email can't be blank`;
        } else if (!this.email.includes('@')) {
          this.emailError = `A valid email address is required`;
        }
        return false;
      }
    },

    startShopping() {
      this.gtmTrackEvent('action', { action: 'Start Shopping', label: 'Click' });
      if (!this.shoppingEnabled) {
        this.$bvModal.show('coming-soon-modal');
      }

      if ((this.shoppingData.recipeData || []).length > 0) {
        if (this.shoppingData.needNativeHelp) {
          this.navigateDeeper({
            title: 'Shop Now',
            component: 'GoShopping',
            data: this.shoppingData,
          });
        } else {
          window.open(this.shoppingData.shoppingLink, '_blank');
        }
      }
    },
  },
  watch: {
    selectedItem(newVal, oldVal) {
      if (!newVal) {
        this.groceryListComponent = 'GroceryListTabs';
      }
    },
    email(val) {
      if (this.emailError) {
        this.emailError = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.errorMsg {
  color: $color-error;
  font-size: 1.4rem;
  font-weight: 200;
  margin: 0 auto 2rem auto;
  max-width: 37.5rem;
  text-align: left;
}
.inputEmail {
  padding-bottom: 20px;
  padding-top: 30px;
}

.grocery-list {
  background-color: $color-grocery-list-bg;
  border-left: 1px solid $color-grocery-list-border;
  box-shadow: $color-grocery-list-shadow;
  font-size: 1.5rem;
  height: 100%;
  max-width: 36rem;
  min-width: 36rem;
  padding: 8rem 0 2rem;
  position: absolute;
  right: 0;
  top: 0;

  .grocery-list-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  &.itemSelected {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }

  &.embedded {
    @extend %scrollable-drawer-content;

    background-color: transparent;
    border-left: 0;
    box-shadow: none;
    max-width: inherit;
    min-width: 100%;
    padding-bottom: 8rem;
    padding-top: 0;
    top: unset;

    .grocery-list-header {
      justify-content: center;
      margin-bottom: 0;
    }

    .grocery-list-subheader {
      display: flex;
      justify-content: center;
      padding: 1rem 0 2rem;
    }
  }

  &.screen-lg {
    padding: 1rem 0 2rem;
    transform: translateX(380px);
    transition: transform 0.6s ease-in-out;
    z-index: 3;

    &.visible {
      transform: translateX(0);
    }

    .grocery-list-header {
      h2 {
        font-size: 2.2rem;
        line-height: 0;

        .icon-clipboard {
          margin-right: 0.5rem;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .grocery-list-subheader button {
      margin: 1rem 0 2rem;
      padding: 1rem 1.2rem;
    }
  }
}
</style>
